import React, { useEffect, useState, useCallback, useMemo } from 'react';
import _ from 'lodash';
import { gateway } from '../../utils/api';
import { openCallToAction } from '../../business/cta';

import CustomContentLoader from './CustomContentLoader';
import LaneWarningsHome from './components/LaneWarningsHome';
import ModalWarningView from '../Modals/ModalWarningView';

// eslint-disable-next-line no-unused-vars
function LaneWarnings({ data }) {
  const [classes, setClasses] = useState(null);
  const [loading, setLoading] = useState(true);
  const [warnings, setWarnings] = useState(null);
  const [errorEventsMessage] = useState('Erro ao buscar avisos');

  // control modal
  const [element, setElement] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const onOpenModal = () => setOpenModal(true);
  const onCloseModal = () => setOpenModal(false);

  // Buscar avisos usando o novo endpoint POST
  async function getWarnings(classCodes, page = 1, limit = 10) {
    try {
      if (!classCodes || classCodes.length === 0) {
        return {
          docs: [],
          totalDocs: 0,
          limit,
          page,
          hasNextPage: false
        };
      }

      const query = `?limit=${limit}&page=${page}`;
      const url = `webbff/lit_app_web/classes/warnings${query}`;
      const body = { classCodes };

      const response = await gateway.post(url, body);
      return response;
    } catch (error) {
      console.log(error);
      return {
        docs: [],
        totalDocs: 0,
        limit,
        page,
        hasNextPage: false
      };
    }
  }

  useEffect(() => {
    async function loadWarnings() {
      if (classes === null) return; // Aguarda fetchClasses completar
      
      setLoading(true);
      
      // Extrair códigos das turmas
      const classCodes = classes.map(item => item.organizationCode).filter(Boolean);
      
      // Buscar avisos usando o novo endpoint
      const response = await getWarnings(classCodes, 1, 10);
      
      setWarnings(response);
      setLoading(false);
    }
    
    loadWarnings();
  }, [classes]);

  useEffect(() => {
    async function fetchClasses() {
      try {
        const response = await gateway('/webbff/lit_app_web/classes');
        setClasses(response);
      } catch (error) {
        console.log(error);
        setClasses([]);
      }
    }
    fetchClasses();
  }, []);

  const openModalWarning = el => {
    setElement(el);
    onOpenModal();
  };

  const handleCallToAction = useCallback(cta => {
    const keys = Object.keys(cta);
    const values = Object.values(cta);
    const obj = {
      key: keys[0],
      value: values[0]
    };
    onCloseModal();
    openCallToAction(obj);
  }, []);

  const title = useMemo(() => {
    return _.get(data, 'lane.name', 'Avisos gerais da turma');
  }, [data]);
  if (loading) {
    const array = new Array(1).fill();
    return (
      <>
        {array.map((_, index) => {
          return (
            <CustomContentLoader
              key={`warning-loader-${index}`}
              tooltipText="Carregando avisos"
              title="Carregando avisos"
            />
          );
        })}
      </>
    );
  }

  if (!loading && warnings) {
    return (
      <div className="cursos col-12" style={{ zIndex: 26 }}>
        <LaneWarningsHome
          title={title}
          data={warnings}
          classes={classes}
          fullButton
          errorWarningsMessage={errorEventsMessage}
          onClick={el => openModalWarning(el)}
        />
        <ModalWarningView
          openModal={openModal}
          onCloseModal={onCloseModal}
          onClick={handleCallToAction}
          element={element}
          onOrganization={false}
        />
      </div>
    );
  }

  return null;
}

export default LaneWarnings;
